export class GenerateReportPayload {
  name: String;
  primaryEntityIds?: number[]; // remove ? when CWR ready
  tradingPartnerIds?: number[]; // remove ? when CWR ready
  domicileId? : number; // remove ? when CWR ready
  domicileName?: string; // remove ? when CWR ready
  isoCode?: string; // remove ? when CWR ready
  primaryEntityId?: number; // remove single entity options when CWR   ready
  tradingPartnerId?: number; // remove single entity options when CWR   ready
  containerId: number;
  currencyId: number;
  targetLanguage: string;
  templateId: string;
  mneId: number;
  selectedTransactionIds: number[];
  executiveSummaryIntro: string;
  executiveSummaryConclusion: string;
  newReportInstance?: boolean;
  reportStage?: string;
  mneCurrency: boolean;
  internalLocalfileReportId?: number;
  taxYear: number;
  shouldDisplayPageNumber?: boolean;
  isLimitationWording?: boolean;
  isActive?: boolean;
}
